<section class="content tab-section d-flex">
  <div class="content-block flex-grow-1">
    <div class="d-flex justify-content-between flex-wrap">
      <div class=" search-cont">
        <div class="s-in form-input">
          <mat-icon class="input-icon">search</mat-icon>
          <input type="text" placeholder="{{'COMMON.SEARCH' | translate}}" class="form-control" [(ngModel)]="searchInput"
            (input)="onSearch($event)" (keyup.enter)="onGo()" />
        </div>
        <div class="go-b" (click)="onGo()">{{'COMMON.GO' | translate}}</div>
        <div class="s-item d-box " (click)="onFilterView()">
          <img src="assets/images/icons/filter_ic.svg" class="img-fluid">
        </div>
      </div>
      <button mat-raised-button color="primary" class=" primary-btn s-lbtn   course-btn no-sh-btn" type="submit"
        (click)="onAddNewSurvey()">
        <i class="fas fa-plus text-white"></i> {{"COMMON.ADD" | translate}} {{"MENUITEMS.STAFFSURVEY.SURVEY" | translate}}</button>
    </div>
    <app-filter *ngIf="isFilterShow" (childEvent)="callApi($event)" [fieldCol]="filterArr"></app-filter>
    <div class="heading-2 new-h mt-3">
      <div class="s-bt" (click)="onAddNewSurvey()"> <i class="fas fa-plus text-white"></i> {{"COMMON.ADD" | translate}} {{"MENUITEMS.STAFFSURVEY.SURVEY" | translate}}</div>
    </div>
    <div class="tab-content flex-grow-1 d-flex flex-column mt-3" *ngIf="!isSpinnerLoading">
      <div class="table-responsive flex-grow-1" *ngIf="dataSource.data.length!=0">
        <table class="mt-3" mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
          class="mat-elevation-z8" >
          <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef>{{"COMMON.TITLE" | translate}}</th>
            <td mat-cell *matCellDef="let element">{{element.tit}}</td>
          </ng-container>
          <ng-container matColumnDef="start_date">
            <th mat-header-cell *matHeaderCellDef>{{"COMMON.STARTDATE" | translate}}
            </th>
            <td mat-cell *matCellDef="let element">{{element.st_dt | date:'dd/MM/yyyy'}}</td>
          </ng-container>
          <ng-container matColumnDef="end_date">
            <th mat-header-cell *matHeaderCellDef>{{"COMMON.ENDDATE" | translate}}
            </th>
            <td mat-cell *matCellDef="let element">{{element.ed_dt | date:'dd/MM/yyyy'}}</td>
          </ng-container>
          <ng-container matColumnDef="survey_count">
            <th mat-header-cell *matHeaderCellDef>{{"MENUITEMS.STAFFSURVEY.SQU" | translate}}
            </th>
            <td mat-cell *matCellDef="let element">{{element.su_c}}</td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>{{"STATUS.TEXT" |translate}}
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="text-bold st-box  d-flex ">
                <span class="active badge-c d-box" *ngIf="element.is_a == '1'">{{"STATUS.ENABLED"|translate}}</span>
                <span class="un-attend badge-c d-box" *ngIf="element.is_a == '0'">{{"STATUS.DISABLED"|translate}}</span>

              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>{{"COMMON.ACTION" | translate}}</th>
            <td mat-cell *matCellDef="let element">
              <div class="d-flex">
                <div class="action-btn  cursor-pointer" (click)="onEditItem(element.su_i)" matTooltip="{{'COMMON.EDIT' | translate}}"><img
                    src="assets/images/icons/edit-icon.svg" class="img-fluid  icon" alt="">
                </div>
                <div class="action-icon  " (click)="onAssignSurvey(element.su_i)" matTooltip="{{'MENUITEMS.STAFFSURVEY.ASSIGNSURVEY' | translate}}">
                  <img src="assets/images/icons/assign_ic (1).svg" class="img-fluid  icon">
                </div>
                <div class="action-icon   stats" (click)="onViewStats(element.su_i)" matTooltip="{{'MENUITEMS.STAFFSURVEY.VIEWSTATS' | translate}}">
                  <img src="assets/images/icons/view-statisticsic.svg" class="img-fluid  icon">
                </div>

                <div class="action-icon" (click)="onDeleteItem(element.su_i)" matTooltip="{{'BUTTON.DELETE' | translate}}">
                  <img src="assets/images/icons/delete-icon.svg" class="img-fluid" alt="">
                </div>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>

      <div class="mat-table__message" *ngIf="dataSource.data.length==0">
        <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
      </div>
      <div class="pagination-cont" *ngIf="dataSource.data.length!=0">
        <div class="show-item">
          {{"COMMON.SIP" | translate}}
          <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event)"
            [(ngModel)]="config.itemsPerPage">
            <option [value]="item" *ngFor="let item of pageSizeOptions">
              {{ item }}
            </option>
          </select>
        </div>
        <div class="page-c">
          <ngb-pagination [collectionSize]="count" [(page)]="config.currentPage" [pageSize]="config.itemsPerPage"
            [maxSize]="maxPaginationSize" (pageChange)="onPageChange($event)"></ngb-pagination>
        </div>
      </div>
    </div>
    <div class="tab-content flex-grow-1 white-bg d-flex align-items-center justify-content-center"
      style="position: relative" *ngIf="isSpinnerLoading">
      <div class="custom-loader"></div>
    </div>

  </div>


</section>
<app-loading-spinner></app-loading-spinner>